import gql from 'graphql-tag';

export default gql`
  query getIdsByFilterFileQuery($filter: FilterPaginationFileInput, $sort: SortFindManyFileInput) {
    getIdsByFilterFileQuery(filter: $filter, sort: $sort)
  }
`;
